import React from 'react';

import {
  convertChangeToLogMessage,
  filterChanges,
  ImportChangelogSectionProps,
} from 'config-migration/import/import-changelog/ImportChangelog';
import LogSection, {getSectionNameForObjectType} from 'config-migration/migration-log/LogSection';
import {ObjectType} from 'config-migration/types/ObjectType';
import TemplateCollectionDAO from 'notebook/entry-templates/collections/TemplateCollectionDAO';
import SubtemplateDAO from 'notebook/entry-templates/SubtemplateDAO';
import TemplateDAO from 'notebook/entry-templates/TemplateDAO';

import {makeSimpleLogMessage} from '../../migration-log/Log';
import {LogMessageGroup} from '../../migration-log/LogSection';

export default function TemplateChangelog(props: ImportChangelogSectionProps): JSX.Element {
  const groupedLogs: Array<LogMessageGroup> = [];

  for (const change of props.changes) {
    const templateChanges = change.slice(1);
    const templateCollectionChange = change[0];

    const filteredTemplateMessages = filterChanges(templateChanges, props.errorsByObjectId).map((change) =>
      convertChangeToLogMessage(
        change,
        props.futureTense,
        props.errorsByObjectId[change.objectId] ?? [],
        props.showObjectUrl
          ? change.objectType === ObjectType.Template
            ? TemplateDAO.templateURL(change.objectApiIdentifier)
            : change.objectType === ObjectType.Subtemplate
              ? SubtemplateDAO.subtemplateURL(change.objectApiIdentifier)
              : null
          : null
      )
    );
    const filteredCollectionMessages = filterChanges([templateCollectionChange], props.errorsByObjectId).map(
      (change) =>
        convertChangeToLogMessage(
          change,
          props.futureTense,
          props.errorsByObjectId[change.objectId] ?? [],
          props.showObjectUrl ? TemplateCollectionDAO.collectionURL(change.objectApiIdentifier) : null
        )
    );

    const collectionDisplayBase = <strong>{props.sectionDisplayName}</strong>;
    if (filteredCollectionMessages.length) {
      groupedLogs.push([...filteredCollectionMessages, ...filteredTemplateMessages]);
    } else if (filteredTemplateMessages.length) {
      const collectionDisplayLink = props.showObjectUrl && (
        <a
          href={TemplateCollectionDAO.collectionURL(templateCollectionChange.objectApiIdentifier)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {collectionDisplayBase}
        </a>
      );
      const logMessage = makeSimpleLogMessage(
        <span>Changes within template collection {collectionDisplayLink || collectionDisplayBase}</span>
      );
      groupedLogs.push([logMessage, ...filteredTemplateMessages]);
    } else {
      groupedLogs.push([
        makeSimpleLogMessage(<span>No changes within template collection {collectionDisplayBase}</span>),
      ]);
    }
  }
  return (
    <LogSection
      sectionDisplayName={getSectionNameForObjectType(ObjectType.Template)}
      logMessageGroups={groupedLogs}
    />
  );
}
